import { type ReactNode, useEffect, useState } from 'react'

import { ConfigContext } from './ConfigContext'
import type { Config } from './types'

export function ConfigProvider({ children }: { children: ReactNode }) {
  const [config, setConfig] = useState<Config | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await fetch('/api/config')
        const data = await response.json()

        if (!data) {
          throw new Error('config not found')
        }
        setConfig({
          kinde: data.iam.kinde,
          awx: data.pay.awx,
        })
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Unable to fetch config')
      } finally {
        setLoading(false)
      }
    }
    fetchConfig()
  }, [])

  return <ConfigContext.Provider value={{ config, loading, error }}>{children}</ConfigContext.Provider>
}
